module.exports = __webpack_public_path__ + "img/9788963011059.35a294a5.jpg";